module.exports = __webpack_public_path__ + "static/media/c8.e40771d4.jpg";